import { create } from 'zustand'

type PricingModalStore = {
  isOpen: boolean
  setClose: () => void
  setOpen: (props?: { highlightedPlanId?: string | null }) => void
  highlightedPlanId?: string | null
}

export const usePricingModal = create<PricingModalStore>((set) => ({
  isOpen: false,
  highlightedPlanId: null,
  setClose: () => set({ isOpen: false, highlightedPlanId: null }),
  setOpen: (props) =>
    set({
      isOpen: true,
      highlightedPlanId: props?.highlightedPlanId,
    }),
}))
